import { render, staticRenderFns } from "./AIModelLayerDetail.vue?vue&type=template&id=4b2caf78&"
import script from "./ai-model-layer-detail.js?vue&type=script&lang=js&"
export * from "./ai-model-layer-detail.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports